import { FC } from 'react';
import { Box, Typography } from '@mui/material';

import CheckedMarkIcon from '../../assets/icons/Checkmark.png';
import { IPlan } from '../Plans/Plans';

import styles from './PlanCard.module.scss';
import { useAppSelector } from '../../hooks/redux';
import { useCurrencySymbol } from '../../hooks/useCurrencySymbol';
import PlanPrice from './PlanPrice';

type PlanCardProps = {
  plan: IPlan;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
  subscription: boolean;
};

const PlanCard: FC<PlanCardProps> = ({ plan, selected, disabled, onClick, subscription }) => {
  const user = useAppSelector(state => state.user);
  const currencySymbol = useCurrencySymbol();

  return (
    <Box className={subscription ? styles.subscription : ''}>
      <Box
        className={`${styles.radioOption} ${selected ? styles.selected : ''} ${disabled ? styles.disabledWrapper : ''} ${subscription ? styles.subscriptionPlan : ''}`}
      >
        <Box className={styles.mainInfo}>
          <Box
            className={styles.titleWrapper}
            justifyContent={subscription ? 'space-between' : 'center'}
          >
            <Typography
              variant="h4Bold"
              className={styles.title}
            >
              {plan.type}
            </Typography>
            {plan.id === user.chosen_plan && subscription && (
              <Typography
                variant="body1"
                className={styles.current}
              >
                Current Plan
              </Typography>
            )}
          </Box>
          <Typography
            variant="h11"
            className={styles.subtitle}
            textAlign={subscription ? 'left' : 'center'}
          >
            {plan.type === 'Basic'
              ? 'For travellers wishing to simplify their full planning and exploring experience with limited assistance from AI'
              : 'For globetrotters seeking premium level AI assistance to plan and explore using the app’s true power'}
          </Typography>
          {plan.type === 'Basic' ? (
            <Typography
              variant="h6Bold"
              className={styles.payment}
            >
              Free
            </Typography>
          ) : (
            <PlanPrice
              plan={plan}
              currencySymbol={currencySymbol}
              className={styles.payment}
            />
          )}
          <Box
            className={styles.benefitsGroup}
            gap={subscription ? 2 : 1}
          >
            {plan.benefits.map((benefit, index) => (
              <Box
                key={index}
                className={styles.benefitWrapper}
              >
                <img
                  src={CheckedMarkIcon}
                  className={styles.benefitIcon}
                  alt="checked-mark"
                />
                <Typography
                  variant="h12"
                  className={styles.benefit}
                >
                  {benefit}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          className={styles.termsWrapper}
          onClick={onClick}
        >
          {!subscription &&
            (plan.type === 'Basic' ? (
              <Typography
                variant="h10Bold"
                className={disabled ? styles.disabled : selected ? styles.selectedTerms : styles.terms}
              >
                Get started
              </Typography>
            ) : (
              <Typography
                variant="h10Bold"
                className={disabled ? styles.disabled : selected ? styles.selectedTerms : styles.terms}
              >
                Buy premium
              </Typography>
            ))}
          {subscription && !user.is_premium && plan.type === 'Premium' && (
            <Typography
              variant="h10Bold"
              onClick={onClick}
              className={disabled ? styles.disabled : selected ? styles.selectedTerms : styles.terms}
            >
              Upgrade to Premium
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PlanCard;
